export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Mon"] = "MON";
    DayOfWeek["Tue"] = "TUE";
    DayOfWeek["Wed"] = "WED";
    DayOfWeek["Thu"] = "THU";
    DayOfWeek["Fri"] = "FRI";
    DayOfWeek["Sat"] = "SAT";
    DayOfWeek["Sun"] = "SUN";
})(DayOfWeek || (DayOfWeek = {}));
